if (!window.collectionTopFilterInitialized) {
    window.collectionTopFilterInitialized = true;

    document.addEventListener('click', function (event) {
        const filterLink = event.target.closest('.js-top-filter');

        if (!filterLink) return;

        event.preventDefault();

        const filterTag = filterLink.dataset.filterTag.trim();

        const searchParams = new URLSearchParams({
            'filter.p.tag': filterTag
        }).toString();

        FacetFiltersForm.renderPage(searchParams);
    });
}
    
document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.querySelector('.collection-top-filter__wrapper');

    if (!wrapper) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    // Drag to scroll
    wrapper.addEventListener('mousedown', (e) => {
        isDown = true;
        wrapper.classList.add('dragging');

        startX = e.pageX - wrapper.offsetLeft;
        scrollLeft = wrapper.scrollLeft;
    });

    document.addEventListener('mouseup', () => {
        isDown = false;
        wrapper.classList.remove('dragging');
    });

    wrapper.addEventListener('mouseleave', () => {
        isDown = false;
        wrapper.classList.remove('dragging');
    });

    wrapper.addEventListener('mousemove', (e) => {
        if (!isDown) return;

        e.preventDefault();

        const x = e.pageX - wrapper.offsetLeft;
        const walk = (x - startX) * 1.5;

        wrapper.scrollLeft = scrollLeft - walk;
    });

    // Shift + wheel = horizontal scroll
    wrapper.addEventListener(
        'wheel',
        (e) => {
            if (!e.shiftKey) return;

            e.preventDefault();
            wrapper.scrollLeft += e.deltaY;
        },
        { passive: false }
    );

    wrapper.addEventListener(
        'wheel',
        (e) => {
            if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
                e.preventDefault();
                wrapper.scrollLeft += e.deltaY;
            }
        },
        { passive: false }
    );
});